module.exports = __webpack_public_path__ + "img/img-chart-02.48ae12e6.png";